import { effectiveLooseChannels, looseChannelsPrefPatch, myLooseChannels, DEFAULT_LOOSE_CHANNELS, type LooseChannelsPosition } from '@tradeoutlet/shared';
import { useChatSections, useWorkspaceId } from '@/lib/hooks';
import { useMyPrefs, useUpdatePrefs } from '@/features/tips/prefs';

/**
 * t446u: where channels without a section sit. The workspace default (people who organise sections set it in
 * Organise sections) and your own choice (Preferences), which wins. Below the sections unless someone changes it.
 */
export function useLooseChannels() {
  const ws = useWorkspaceId();
  const sections = useChatSections();
  const prefs = useMyPrefs();
  const update = useUpdatePrefs();
  const workspaceDefault: LooseChannelsPosition = sections.data?.loose_channels ?? DEFAULT_LOOSE_CHANNELS;
  const mine = myLooseChannels(prefs.data?.prefs, ws);
  return {
    workspaceDefault,
    mine,
    position: effectiveLooseChannels(workspaceDefault, mine),
    ready: Boolean(sections.data && prefs.data),
    setMine: (v: LooseChannelsPosition | null) => (ws ? update.mutateAsync(looseChannelsPrefPatch(ws, v)) : Promise.resolve(undefined)),
  };
}
